export default "__VITE_ASSET__CUOFtFCz__"